// extracted by mini-css-extract-plugin
export default {"dropdownNavbarItemMobile":"dropdownNavbarItemMobile_yXZl"};